/*jslint browser: true, devel: true */
"use strict";

function getCurrencySymbol() {
  return document.cookie.includes('currency=EUR') ? '€' : '$';
}

// --------
// Dropzone
// --------

var debug = false;
var thisDropzone;
var maxImageWidth = 10000;
var maxImageHeight = 10000;
var submissionForm = document.forms[0];
var selectButton = document.getElementById("select");
var variablePricing = false;

var progressBarContainer = document.querySelector('.dz-progress-bar-total');
var progressBarText = document.querySelector('.dz-progress-bar-text');
var progressBarTotal = document.querySelector('.dz-progress-bar-total .dz-upload');
var termsconditions = document.querySelector('.terms-conditions');
var progresstext = document.querySelector('.progress-text');

// Define the prices array to match the one in your submission.php file
var prices = {
    1: 15.00,
    3: 30.00,
    6: 40.00,
    7: 45.00,
    8: 50.00,
    9: 55.00,
    10: 60.00,
    11: 65.00,
    12: 70.00
};
var totalCost;

Dropzone.options.submission = {
    url: "/wp-json/tip/v1/upload",
    maxFilesize: 8,
    maxFiles: 12,
    acceptedFiles: "image/jpg,image/jpeg,image/png",
    autoProcessQueue: false,
    parallelUploads: 1,
    uploadMultiple: false,
    timeout: (10 * 60 * 1000),
    addRemoveLinks: true,
    clickable: "#add-image",
    thumbnailWidth: null,
    thumbnailHeight: null,
    previewTemplate: document.getElementById("preview-template").innerHTML,
    previewsContainer: document.getElementById("preview-container"),
    dictDefaultMessage: "",
    retryChunks: false,
    dictRemoveFile: "Remove",
    dictCancelUpload: "Cancel",
    dictFileTooBig: "Image is too big ({{filesize}}MB), please upload JPEG or PNG Max. 6MB",

    init: function() {
        if (debug) console.log("Dropzone loaded.");

        thisDropzone = this;

        let uploadWatchdog;
        let totalFiles = 0;
        let completedFiles = 0;
        let uploadAborted = false;
        let submitStarted = false;


        // var buttonClear = document.getElementById("clear");
        var buttonAdd = document.getElementById("add-image");
        var addButtons = document.getElementById("add-buttons");
        var countInfo = document.getElementById("counter-info");
        var elemMessage = document.getElementById("uploader-message");
        var hiddenInput = document.querySelectorAll(".dz-hidden-input")[0];
        var removeImage = document.querySelectorAll(".dz-remove")[0];
        var allAdded = document.querySelectorAll(".dz-clickable")[1];
        var countLeft  = thisDropzone.options.maxFiles - thisDropzone.files.length;
        var totalPrice = document.getElementById("totalprice");

        // Inside the init function of Dropzone options

        // Disable Dropzone functionality initially
        thisDropzone.hiddenFileInput.setAttribute("disabled", "disabled");

        // Update event listener for dropzone clickable area
        var clickableArea = document.querySelector("#add-image");
        var self = this; // Preserve reference to Dropzone instance

        clickableArea.addEventListener("click", function(event) {
            event.preventDefault(); // ALWAYS prevent form submit

            var selectedPrice = document.querySelector('input[name="price"]:checked');
            if (!selectedPrice) {
                displayMessage({ status: "error", message: "Please select a pricing option first." });
                return;
            }

            self.hiddenFileInput.removeAttribute("disabled");
            self.hiddenFileInput.click();
        });

        // ----------
        // Submission
        // ----------

        selectButton.addEventListener("click", function(event){
            uploadAborted = false;
            if ([1,3,6].includes(thisDropzone.files.length)) {

                // reset state
                uploadedFiles = [];
                submitStarted = true; // ✅ ARM QUEUE

                // start QUEUE watchdog
                clearTimeout(uploadWatchdog);
                uploadWatchdog = setTimeout(function () {
                    displayMessage({
                        status: "error",
                        message: "Upload timed out. Please retry."
                    });
                    thisDropzone.removeAllFiles(true);
                    selectButton.classList.remove("is-loading");
                    selectButton.disabled = false;
                }, 3 * 60 * 1000);

                totalFiles = thisDropzone.getAcceptedFiles().length;
                completedFiles = 0;

                progressBarTotal.style.width = "0%";
                progressBarContainer.classList.remove("hidden");
                progresstext.classList.remove("hidden");
                progressBarContainer.classList.add("processing");
                termsconditions.classList.add("hidden");
                progressBarText.textContent = `Uploading 1 of ${totalFiles}`;
                selectButton.disabled = true;

                thisDropzone.processQueue();

            } else {
                event.preventDefault();
                selectButton.setAttribute("disabled", "disabled");
                displayMessage({
                    status: "error",
                    message: "You can upload 1, 3 or 6 images only."
                });
            }
        });


        this.on("complete", function () {

            // ❌ Never chain uploads unless submit was clicked
            if (!submitStarted) {
                return;
            }

            if (
                this.getQueuedFiles().length > 0 &&
                this.getUploadingFiles().length === 0
            ) {
                this.processQueue();
            }
        });



        this.on("error", function(file, errorMessage, xhr) {
            if (thisDropzone._redirecting) return;
            submitStarted = false;

            // If no xhr, it's not a network interruption. It's typically validation (max files, invalid type, too big, etc.)
            let message;

            if (!xhr) {
                uploadAborted = true;
                message = (typeof errorMessage === "string" && errorMessage) ? errorMessage : "Upload error. Please try again.";
            } else if (xhr.status === 0) {
                message = "Upload interrupted. Please check your connection and try again.";
            } else if (xhr.status >= 500) {
                message = "Server error. Please try again later.";
            } else {
                message = "An error occurred while uploading. Please try again.";
            }

            // Only log "network-ish" issues (optional, but recommended)
            if (xhr && (xhr.status === 0 || xhr.status >= 400)) {
                fetch("/log-client-upload-error.php", {
                    method: "POST",
                    keepalive: true,
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        message: errorMessage,
                        status: xhr.status,
                        file: { name: file.name, size: file.size, type: file.type },
                        ua: navigator.userAgent
                    })
                });
            }

            displayMessage({ status: "error", message: message });
        });

        this.on("maxfilesexceeded", function(file) {
            uploadAborted = true;
            submitStarted = false;

            // Remove the extra file immediately
            this.removeFile(file);

            displayMessage({
                status: "error",
                message: "You can upload 1, 3 or 6 images only."
            });
        });


        // ------------------
        // File added handler
        // ------------------

        thisDropzone.on("addedfile", function(file) {
            console.log("File added.");
            // Update total cost display
            updateTotalCost();

            // elemMessage.innerHTML = "&nbsp;";

            // remove file if found to be duplicate
            // SO: http://stackoverflow.com/a/32841273/401980
            if (thisDropzone.files.length) {
                var _i, _len;

                for (
                    _i = 0, _len = thisDropzone.files.length;
                    _i < _len - 1;
                    _i++
                ) {
                    // -1 to exclude current file

                    if (
                        thisDropzone.files[_i].name === file.name &&
                        thisDropzone.files[_i].size === file.size &&
                        thisDropzone.files[_i].lastModifiedDate.toString() ===
                            file.lastModifiedDate.toString()
                    ) {
                        if (debug) console.log("Duplicate detected, removing.");
                        thisDropzone.removeFile(file);

                        displayMessage({
                            status: "error",
                            message: "Image already added."
                        });
                    }
                }
            }

            var countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
            var toomuch = thisDropzone.files.length - thisDropzone.options.maxFiles;

            if (variablePricing === false) {
            if (thisDropzone.files.length > thisDropzone.options.maxFiles) {
                if (debug) console.log("Exceeds max file limit, removing.");
                thisDropzone.removeFile(file);

            } else if (thisDropzone.files.length === thisDropzone.options.maxFiles) {
                console.log("File limit reached, enabling submission.");
                addButtons.removeAttribute("hidden");
                selectButton.removeAttribute("disabled");
                document.querySelector(".btn-add-image").classList.add("hidden");
                buttonAdd.hidden = true;
                countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;

            } else if (thisDropzone.files.length < thisDropzone.options.maxFiles) {
                console.log("File added, still below limit.");
                buttonAdd.hidden = true;
                selectButton.setAttribute("disabled", "disabled");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;

                if (countLeft == 1) {
                    countInfo.value = "Please add " + countLeft + " image.";
                }
                if (countLeft != 1) {
                    countInfo.value = "Please add " + countLeft + " images.";
                }
            }
            }
            else if (variablePricing) {

                if ( thisDropzone.files.length >= 6 && thisDropzone.files.length != 12) {
                updateTotalCost();
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").removeAttribute("disabled");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                // totalPrice.removeAttribute("hidden");
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                }

                else if ( thisDropzone.files.length === 12) {
                updateTotalCost();
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                document.querySelector(".btn-add-image").classList.add("hidden");
                document.querySelector('.dz-message').style.display = "none";
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                // totalPrice.removeAttribute("hidden");
                }
            };

            // If not logged in
            if (!document.body.classList.contains( 'logged-in' )) {
                console.log("Not logged in.");
                displayMessage({
                        status: "error",
                        message: "Please login or register first."
                        });
            }


            // If we have ANY files, enable the count
            if (thisDropzone.files.length >= 1 ) {
                if (debug) console.log("We have files, enable clear, hide message.");

                addButtons.removeAttribute("hidden");
                document.querySelector('.dz-message').style.display = "none";
            } else if (thisDropzone.files.length <= 0 ) {
                console.log("All images removed");
                addButtons.removeAttribute("hidden");
            }

            // Add caption and title inputs and append them to form
            var caption = file.caption == "undefined" ? "" : file.caption;
            var image_count = thisDropzone.files.length - 1;

            const html = `
                <div class="dz-image-info">
                    <label class="input-wrapper">
                        <input class="input input-small extended" type="text" name="meta[${image_count}][title]" placeholder="Title">
                        <span class="dz-checkmark">✓</span>
                    </label>
                    <label class="input-wrapper">
                        <textarea class="input input-small textarea extended" name="meta[${image_count}][description]" placeholder="Description: tell us about this image (story, location, year)"></textarea>
                        <span class="dz-checkmark">✓</span>
                    </label>
                </div>
            `;

            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = html.trim();
            file._captionBox = tempContainer.firstChild;


            file.previewElement.appendChild(file._captionBox);

            const inputs = file._captionBox.querySelectorAll('input, textarea');
            inputs.forEach(input => {
                const wrapper = input.closest('.input-wrapper');
                input.addEventListener('input', () => {
                    if (input.value.trim() !== '') {
                        wrapper.classList.add('filled');
                    } else {
                        wrapper.classList.remove('filled');
                    }
                });
            });
        });

        this.on("thumbnail", function(file) {
            if (file.width > maxImageWidth || file.height > maxImageHeight) {
                thisDropzone.removeFile(file);
                displayMessage({
                    status: "error",
                    message: "This image's resolution exceeds the maximum of 10000 pixels."
                });
            }
        });

        this.on("removedfile", function(file) {
            console.log("File removed, disabling submit.");
            // Update total cost display
            updateTotalCost();
            countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;

            if (variablePricing && thisDropzone.files.length < 6) {
                thisDropzone.options.maxFiles = 6;
                countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
                updateTotalCost();
                if (countLeft == 1) {
                    countInfo.value = "Please add " + countLeft + " image minimum.";
                }
                if (countLeft != 1) {
                    countInfo.value = "Please add " + countLeft + " images minimum.";
                }
                selectButton.setAttribute("disabled","disabled");
                // totalPrice.setAttribute("hidden","hidden");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                document.querySelector(".btn-add-image").removeAttribute("disabled");

            }

            if (variablePricing && thisDropzone.files.length >= 6) { 
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                allAdded.setAttribute("disabled", "");
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").classList.remove("hidden");
                document.querySelector(".btn-add-image").removeAttribute("disabled");
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
            }

            if (variablePricing && thisDropzone.files.length >= 13) { 
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                allAdded.setAttribute("disabled", "");
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").classList.add("hidden");
                document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                countInfo.value = "❌ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
            }

            if (variablePricing == false) {
                if ( thisDropzone.options.maxFiles === 1) {
                    var toomuch = thisDropzone.files.length - 1;
                        if (thisDropzone.files.length < 1) {
                            countInfo.value = "Please add 1 image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (thisDropzone.files.length > 1) {
                            countInfo.value = "Please remove " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (thisDropzone.files.length == 1) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
                if ( thisDropzone.options.maxFiles === 3) {
                    var toomuch = 3 - thisDropzone.files.length;
                        if (toomuch == 1) {
                            countInfo.value = "Please add " + toomuch + " image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft > 1) {
                            countInfo.value = "Please add " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft == 0) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
                if ( thisDropzone.options.maxFiles === 6) {
                    var toomuch = 6 - thisDropzone.files.length;
                        if (toomuch == 1) {
                            countInfo.value = "Please add " + toomuch + " image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft > 1) {
                            countInfo.value = "Please add " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft == 0) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
            }

            // if we don't have any files, disable
            // clearing and show drop message
            if (thisDropzone.files.length < 1) {
                console.log("No more files.");
                countInfo.value = "";
                document.querySelector('.dz-message').style.display = "";
                document.querySelector(".dz-message").removeAttribute("hidden");
            }
        });

        // Store uploaded file IDs
        var uploadedFiles = [];

        this.on("sending", function (file) {
            selectButton.classList.add("is-loading");
            selectButton.disabled = true;
        });

        this.on("uploadprogress", function (file, progress) {
            if (!submitStarted || totalFiles === 0) return;

            // progress = 0–100 for *current file*
            const fileIndex = completedFiles; // files already done
            const overallProgress =
                ((fileIndex + progress / 100) / totalFiles) * 100;

            progressBarTotal.style.width = Math.min(overallProgress, 100) + "%";
        });


        // Handle successful file upload to REST endpoint
        this.on("success", function (file, response) {
            completedFiles++;

            const percent = Math.round((completedFiles / totalFiles) * 100);
            progressBarTotal.style.width = percent + "%";

            if (completedFiles < totalFiles) {
                progressBarText.textContent = `Uploading ${completedFiles + 1} of ${totalFiles}`;
            } else {
                progressBarText.textContent = "Processing submission…";
            }

            if (response && response.success && response.files && Array.isArray(response.files)) {
                response.files.forEach(function (fileData) {
                    uploadedFiles.push(fileData);
                });

                // ✅ Safe, non-sensitive log
                if (debug) {
                    console.log("[DROPZONE] Uploaded files count:", uploadedFiles.length);
                }

            } else {
                displayMessage({
                    status: "error",
                    message: "Upload failed. Please try again."
                });
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
            }
        });


        // Handle completion of all uploads
        this.on("queuecomplete", function () {
            submitStarted = false; // ✅ DISARM

            clearTimeout(uploadWatchdog);

            if (uploadAborted) {
                uploadAborted = false;
                return;
            }

            if (
                uploadedFiles.length > 0 &&
                thisDropzone.getAcceptedFiles().length === uploadedFiles.length
            ) {
                submitFormWithFiles();
            } else {
                displayMessage({
                    status: "error",
                    message: "One or more images failed to upload. Please retry."
                });
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
            }
        });


        // Submit form with uploaded file IDs
        function submitFormWithFiles() {
            console.log('[DROPZONE] submitFormWithFiles called, uploadedFiles.length:', uploadedFiles.length);
            
            if (uploadedFiles.length === 0) {
                console.error('[DROPZONE] ERROR: No files to submit');
                displayMessage({
                    status: "error",
                    message: "No files were uploaded. Please try again."
                });
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
                return;
            }

            // Get form data
            var formData = new FormData(submissionForm);
            formData.append('action', 'submission');
            
            var uploadedFilesJson = JSON.stringify(uploadedFiles);
            formData.append('uploaded_files', uploadedFilesJson);
            
            console.log('[DROPZONE] Submitting form with uploaded_files:', uploadedFilesJson.substring(0, 200) + '...');

            // Submit to admin-post.php
            var xhr = new XMLHttpRequest();
            xhr.open('POST', ajax_urls.admin_ajax, true);
            
            xhr.onload = function() {
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
                
                if (xhr.status === 200) {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        if (response.success) {
                            displayMessage({
                                status: "success",
                                message: "Your files have been uploaded, you will be redirected shortly."
                            });
                            window.location.href = "/submissions/" + response.data.redirect_url;
                        } else {
                            displayMessage({
                                status: "error",
                                message: response.message || "An error occurred. Please try again."
                            });
                        }
                    } catch (e) {
                        displayMessage({
                            status: "error",
                            message: "An error occurred processing your submission. Please try again."
                        });
                    }
                } else {
                    displayMessage({
                        status: "error",
                        message: "Server error. Please try again later."
                    });
                }
            };
            
            xhr.onerror = function() {
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
                displayMessage({
                    status: "error",
                    message: "Network error. Please check your connection and try again."
                });
            };
            
            xhr.send(formData);
        }
    }
};

document.addEventListener("DOMContentLoaded", function() {
    console.log("Submissions loaded.");
    
    // ------------------------------------------
    // Submission form info toggling (for titles)
    // ------------------------------------------

    submissionForm.addEventListener("change", function(e) {
        var countInfo = document.getElementById("counter-info");
        var radioSelected = document.querySelector('input[name="price"]:checked');
        thisDropzone.options.maxFiles = radioSelected.value;
        updateTotalCost();
        document.getElementById("total-cost").textContent = getCurrencySymbol() + totalCost;
        var totalPrice = document.getElementById("totalprice");
        var addButtons = document.getElementById("add-buttons");
        var allAdded = document.querySelectorAll(".dz-clickable")[1];

        if (+e.target.value === 1) {
            thisDropzone.options.maxFiles = 1;
            variablePricing = false;
        }

        if (+e.target.value === 3) {
            thisDropzone.options.maxFiles = 3;
            variablePricing = false;
        }

        if (+e.target.value === 6) {
            thisDropzone.options.maxFiles = 6;
            variablePricing = false;
        }

        var countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
        var toomuch = thisDropzone.files.length - thisDropzone.options.maxFiles;

        if (variablePricing === false) {
        if (thisDropzone.files.length < thisDropzone.options.maxFiles) {
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            if (countLeft == 1) {
                countInfo.value = "Please add " + countLeft + " image.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please add " + countLeft + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length > thisDropzone.options.maxFiles) {
            document.querySelector(".btn-add-image").classList.add("hidden");
            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
            if (toomuch == 1) {
            countInfo.value = "Please remove " + toomuch + " image.";
            }
            if (toomuch > 1) {
            countInfo.value = "Please remove " + toomuch + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length == thisDropzone.options.maxFiles) {
            selectButton.removeAttribute("disabled");
            console.log("Number of images reached.");
            addButtons.removeAttribute("hidden");
            allAdded.setAttribute("disabled", "");
            document.querySelector(".btn-add-image").classList.add("hidden");
            document.querySelector('.dz-message').style.display = "none";
            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
        }
    }

     if (variablePricing === true) {
        if (thisDropzone.files.length < 6) {
            countLeft = 6 - thisDropzone.files.length;
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            if (countLeft == 1) {
                countInfo.value = "Please add " + countLeft + " image minimum.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please add " + countLeft + " images minimum.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length >= 6) {
            selectButton.removeAttribute("disabled");
            console.log("Number of images reached.");
            addButtons.removeAttribute("hidden");
            allAdded.setAttribute("disabled", "");
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            document.querySelector('.dz-message').style.display = "none";
            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / 12";
        }
        if (thisDropzone.files.length >= 13) {
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            countLeft = thisDropzone.files.length - 12;
            if (countLeft == 1) {
                countInfo.value = "Please remove " + countLeft + " image.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please remove " + countLeft + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
     }
    });
});


// ----------------------------------
// remove hidden class from targetted
// element, add it to clicked element
// ----------------------------------

var showButton = document.querySelector(".js-show");

showButton && showButton.addEventListener("click", function(e){
    e.preventDefault();

    var target = document.getElementById(this.getAttribute("data-target"));

    this.classList.add("hidden");
    target.classList.remove("hidden");
    target.focus();
});


// ----------------------------------
// remove hidden class from targetted
// element, add it to clicked element
// ----------------------------------

var voucherButton = document.querySelector(".js-voucher");
var voucherMessage = document.querySelector(".js-voucher-message");



voucherButton && voucherButton.addEventListener("click", function(e){
    e.preventDefault();

    var voucher = submissionForm.voucher.value;
    var email = submissionForm.email.value;
    var givenName = submissionForm.fname.value;
    var surname = submissionForm.lname.value;
    var voucherClass = document.querySelector(".voucherclass");

    var previousPrices = document.querySelectorAll(".previous-price");
    var currentPrices = document.querySelectorAll(".price");
    var applyButton = document.getElementById("applybutton");

    voucherButton.classList.add("is-loading");

    var queryURI = encodeData({
        action: "voucher",
        voucher: voucher,
        email: email,
    });

    var xhr = new XMLHttpRequest();

    xhr.open("POST", ajax_urls.admin_ajax);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    xhr.addEventListener("load", function(){
        if (debug) console.log(xhr);

        console.warn(xhr.responseText)
        var response = JSON.parse(xhr.responseText);

        voucherButton.setAttribute("disabled", true);
        voucherButton.classList.remove("is-loading");

        voucherMessage.innerHTML = response.message;
        voucherMessage.classList.add("is-active");

        setTimeout(function() {
            voucherMessage.classList.remove("is-active");
        }, 5000);

        if (response.status === "success") {
            
            currentPrices.forEach(function(el, index){
    
                var previousPrice = parseInt(el.innerHTML);
    
                previousPrices[index].classList.add("is-visible");
                voucherClass.setAttribute("readonly", true);
                applyButton.innerHTML = "Applied!";
                voucherButton.setAttribute("disabled", true);
    
                animateValue(el, previousPrice, response.prices[index], 500);
            });

        } else {

            voucherButton.disabled = false;
            voucherClass.value = "";

        }

    });

    xhr.send(queryURI);
});


// Function to update total cost display
function updateTotalCost() {
    var countInfo = document.getElementById("counter-info");
    var totalCostElement = document.getElementById("total-cost");

    // Calculate total cost based on the number of images in Dropzone
    var numImages = thisDropzone.files.length;
    totalCost = prices[numImages] || prices[12]; // Default to max price if not found

    // Update the total cost display in the DOM
    totalCostElement.textContent = getCurrencySymbol() + totalCost;
}


function displayMessage(messageObj) {

    var messageElem = document.getElementById("message-box");
    var submitElem = document.getElementById("select");

    submitElem.classList.remove("is-loading");
    submitElem.disabled = false;

    messageElem.classList.remove("success");
    messageElem.classList.remove("error");

    messageElem.classList.add(messageObj.status);
    messageElem.innerHTML = messageObj.message;

    messageElem.classList.add("isActive");

    setTimeout(function() {
        messageElem.classList.remove("isActive");
    }, 8000);
}

// encodes the given object into a usable URI
// with keys and values to be passed via XMLHttpRequest
var encodeData = function(object) {

    return Object.keys(object).map(
        function(k){
            return encodeURIComponent(k) + "=" + encodeURIComponent(object[k])
        }
    ).join("&");
};

function animateValue(el, start, end, duration) {

    // animating equal values kinda breaks this
    if (start == end) return false;

    var range = end - start;
    var current = start;
    var increment = end > start? .5 : -.5;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = el;
    var timer = setInterval(function() {
        current += increment;
        obj.innerHTML = current;
        if (current == end) {
            clearInterval(timer);
        }
    }, 10);
}

function handlePricingSelection(imageFee, priceCount) {
    document.getElementById('pricingoption').value = document.getElementsByClassName('pricingrow')[priceCount].value;
}


